import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

export const DOC = gql`
  ${fragments.organization.DOC}
  mutation UpdateOrganizationJointUse(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $organizationId: ID!
    $organizationEntityId: ID!
    $update: OrganizationJointUseUpdate!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                updateOrganizationJointUse(
                  organizationId: $organizationId
                  organizationEntityId: $organizationEntityId
                  update: $update
                ) {
                  ...FragmentOrganization
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.UpdateOrganizationJointUseMutation,
    ents.extra.space.Organization,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'updateOrganizationJointUse',
                fragments.organization.TRANSFORMER,
              ),
            ),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.UpdateOrganizationJointUseMutation,
  ents.extra.space.Organization,
  graphql.schema.UpdateOrganizationJointUseMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
